var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 376,
    viewBox: "0 0 361 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.9857 38.4709C111.701 19.3371 127.059 9.77014 143.562 5.14278C159.947 0.548582 177.122 -0.508259 193.946 2.04239C210.893 4.61146 227.307 12.2233 260.137 27.4468C292.065 44.4803 308.029 52.9971 320.288 64.9756C332.459 76.8683 341.962 91.2136 348.165 107.06C354.414 123.02 356.029 141.041 359.26 177.084C360.472 213.252 361.079 231.335 356.835 247.941C352.621 264.428 344.949 279.83 334.327 293.126C323.63 306.517 308.83 316.927 279.231 337.746C248.516 356.88 233.158 366.447 216.655 371.074C200.27 375.668 183.095 376.725 166.271 374.175C149.324 371.606 132.91 363.994 100.08 348.77C68.1517 331.737 52.1877 323.22 39.9286 311.241C27.7575 299.349 18.2548 285.003 12.0515 269.158C5.80331 253.197 4.18789 235.176 0.957057 199.133C-0.255559 162.965 -0.861865 144.882 3.38234 128.276C7.59613 111.789 15.2682 96.3866 25.8895 83.0914C36.5874 69.7002 51.3868 59.2904 80.9857 38.4709Z",
    fill: "#FFCD23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon1);
export default __webpack_public_path__ + "static/media/hexagon1.f56375fb93f41206695a70b9d5dd43d9.svg";
export { ForwardRef as ReactComponent };